import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RmsUserGuideConstants {
  public static RespondersCategory: number = 1;
  public static TeamsCategory: number = 2;
  public static SelfServiceCategory: number = 3;
  public static CredentialingCategory: number = 4;
  public static FinanceIPRCategory: number = 5;
  public static FinanceTeamTimeAndSalaryCategory: number = 6;
  public static EventsCategory: number = 7;
  public static EventLogsCategory: number = 8;
  public static DeploymentRostersCategory: number = 9;
  public static DeploymentTemplatesCategory: number = 10;
  public static TeamAvailabilityCategory = 11;
  public static EventResponderStatusCategory: number = 12;
  public static TravelRostersCategory: number = 13;
  public static TravelMasterTrackingSpreadsheetCategory: number = 14;
  public static PARSCategory: number = 15;
  public static HIRCategory = 16;
  public static TERCategory = 17;
}